import { render } from "./GoBack.vue?vue&type=template&id=67e06e0e"
import script from "./GoBack.vue?vue&type=script&lang=js"
export * from "./GoBack.vue?vue&type=script&lang=js"

import "./GoBack.vue?vue&type=style&index=0&id=67e06e0e&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/navbar/GoBack.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67e06e0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67e06e0e', __exports__)) {
    console.log('reload')
    api.reload('67e06e0e', __exports__)
  }
  
  module.hot.accept("./GoBack.vue?vue&type=template&id=67e06e0e", () => {
    console.log('re-render')
    api.rerender('67e06e0e', render)
  })

}


export default __exports__